import { StorageDepot } from "@/types";
import { getData } from "./axios-service";

function modelMapper(inputStorageDepot: any): StorageDepot {
    return {
        id: inputStorageDepot.id,
        name: inputStorageDepot.name,
        address: inputStorageDepot.address
    };
}

export function modelMapperArray(inputArray: any[]): StorageDepot[] {
    return inputArray.map(modelMapper);
}

export async function getAllStorageDepots(): Promise<StorageDepot[]> {
    const storageDepots = await getData<StorageDepot[]>("storage-depots");
    return modelMapperArray(storageDepots ?? []);
}